
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificate/verify",
      function () {
        return require("private-next-pages/certificate/verify/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificate/verify"])
      });
    }
  